import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgArrowRightUp = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M7.03345 17.6496L16.636 8.04708L16.6147 16.7657C16.6077 17.0415 16.834 17.2678 17.1168 17.2678C17.3996 17.2678 17.6188 17.0485 17.6188 16.7657L17.6471 6.83793L17.6471 6.34295L17.1521 6.34295L7.22437 6.37124C7.08295 6.37124 6.95567 6.4278 6.87082 6.51266C6.78597 6.59751 6.72232 6.73186 6.7294 6.86621C6.73647 7.14198 6.95567 7.36119 7.23144 7.36826L15.9501 7.34704L6.34049 16.9566C6.1425 17.1546 6.1425 17.4657 6.34049 17.6637C6.53848 17.8617 6.84961 17.8617 7.0476 17.6637L7.03345 17.6496Z' />
  </svg>
);
export default SvgArrowRightUp;
